import useTrans from "@/hooks/useTrans";
import { ItemCheckOut } from "@/pages/checkout/components";
import { useCartContext } from "@/setup/cartProvider";
import { Box, Button, Center, Grid, Text, Title } from "@mantine/core";
import { FiXCircle } from "@react-icons/all-files/fi/FiXCircle";
import { useRouter } from "next/router";
import numeral from "numeral";
import React, { useEffect } from "react";
import useStyles from "../styles/CartRightSection";
import AddVoucher from "./AddVoucher";
import PickerDVVC from "./PickerDVVC/index";
import SubmitPrivacy from "@/common/SubmitPrivacy";

function CartRightSection() {
  // const child = <Skeleton height={140} radius="md" animate={false} />;
  const { classes } = useStyles();
  const trans = useTrans();
  const { infoOrder, createOrder, info_order, setInfoOrder, deleteVoucher } =
    useCartContext();
    // console.log('fee', infoOrder.feeShip)

  const router = useRouter();

  const isCart = router.pathname === "/cart";
  const [checked, setChecked] = React.useState(false);
  const [isFirst, setIsFirst] = React.useState(true);

  const submitOrder = () => {
    if (!checked && !isCart) {
      setIsFirst(false);
      return;
    }

    const trang_thai = router.pathname === "/cart" ? "LCT" : "0";
    createOrder({ trang_thai });
  };

  useEffect(() => {
    if (info_order?._id && router.pathname === "/checkout") {
      setInfoOrder({
        ...infoOrder,
        ...{
          totalPrice: info_order?.t_tt_nt,
          tempPrice: info_order?.t_tien_nt,
          voucherValue: info_order?.tien_evoucher,
        },
      });
    }
  }, [info_order]);

  return (
    <Grid.Col lg={4}>
      <Grid>
        {/* {router.pathname === "/checkout" && <AddVoucher />} */}
        <Grid.Col md={12} lg={12}>
          <Box className={classes.container}>
            <Center className={classes.centerBoxUnderline}>
              <Title order={6}>{trans?.cart.cartInfo}</Title>
            </Center>
            <Box className={classes.centerBoxUnderline}>
              <PickerDVVC />
            </Box>
            <Box className={classes.centerBoxUnderline}>
              <Box className={classes.centerBoxUnderlineSpaceBT}>
                <Text size={14} weight="500">
                  {trans?.cart.temp}
                </Text>
                <Text>{numeral(infoOrder?.tempPrice).format(0, 0)}</Text>
              </Box>

              {/* {infoOrder?.voucherValue > 0 && (
                <Box
                  className={classes.centerBoxUnderlineSpaceBT}
                  sx={{ position: "relative" }}
                >
                  <Text size={14} weight="500">
                    Ưu đãi giảm giá
                  </Text>
                  <Text color="red">
                    {"-"}
                    {numeral(infoOrder?.voucherValue).format(0, 0)}
                  </Text>
                  <Box sx={{ position: "absolute", right: -25 }}>
                    <FiXCircle
                      onClick={() => {
                        deleteVoucher(info_order);
                      }}
                      size={20}
                    />
                  </Box>
                </Box>
              )} */}

              {!isCart &&
              infoOrder?.feeShip &&
              infoOrder?.feeShip > (infoOrder?.freeShipValue || 0) ? (
                <Box className={classes.centerBoxUnderlineSpaceBT}>
                  <Text size={14} weight="500">
                    {trans.cart.ship}
                  </Text>
                  <Text>{numeral(infoOrder.feeShip || 0).format(0, 0)}</Text>
                </Box>
              ) : (
                !isCart &&
                infoOrder?.freeShipValue >= (infoOrder?.tien_phi_vc || 0) && (
                  <Box className={classes.centerBoxUnderlineSpaceBT}>
                    <Text size={14} weight="500">
                      {trans.cart.freeship}
                    </Text>
                  </Box>
                )
              )}
            </Box>

            <Box className={classes.centerBoxUnderline}>
              <Box className={classes.centerBoxUnderlineSpaceBT}>
                <Text size={18} weight="700">
                  {trans.cart.total}
                </Text>
                <Text size={18} weight="700">
                  {numeral(infoOrder?.totalPrice).format(0, 0)}
                </Text>
              </Box>
              <Button onClick={submitOrder} fullWidth>
                {trans.cart.pay}
              </Button>
            </Box>
          </Box>
        </Grid.Col>
        <SubmitPrivacy
          isCart={isCart}
          checked={checked}
          setChecked={setChecked}
          isFirst={isFirst}
          setIsFirst={setIsFirst}
        />
        {router.pathname === "/checkout" && (
          <Grid.Col md={12} lg={12}>
            <ItemCheckOut />
          </Grid.Col>
        )}
      </Grid>
    </Grid.Col>
  );
}

export default CartRightSection;
